import * as React from "react";
import { cx } from "../internal/cx.js";
const Card = React.forwardRef(function Card2({ as = "div", padded = false, className, ...rest }, ref) {
  return React.createElement(as, {
    ...rest,
    ref,
    className: cx("ev-card", padded && "ev-card--pad", className)
  });
});
export {
  Card
};
//# sourceMappingURL=Card.js.map
